<template>
	<div id="wallet">
		<div class="wallet" :style="'margin-top:'+playHeight+'px'">
			<img :src="imgPath+'home/wallet.png'" @click="showSalesList">
		</div>

		<div class="sales" v-show="showSales">
			<div class="sales_musk"></div>
			<div class="sales_box">
				<img class="bg" src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/home/sales-bg.png">
				<img class="close" @click="closeSales" src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/home/close.png">
				<div class="tabs">
					<div class="tabs_title">
						<div class="btn" :class="{cur:(curSale == 1)}" @click="changeCur(1)">
							<a>我的动态</a>
						</div>
						<div class="btn" :class="{cur:(curSale == 2)}" @click="changeCur(2)">
							<a>全部动态</a>
						</div>
					</div>
					<div v-show="curSale == 1" class="list" v-waterfall-lower="getSalesList" waterfall-disabled="disabledSale" waterfall-offset="100">
						<ul v-if="salesList.length">
							<li v-for="item in salesList" class="ellipsis">
								<template v-if="item.share_fans_id == 0">
									<span class="orange">{{item.nick}}</span> 从你的链接购买了{{item.buy_num}}件商品
								</template>
								<template v-else>
									<span class="orange">{{item.nick}}</span> 获得了<span class="pink">{{item.money/100}}元</span>分享收益
								</template>
							</li>
						</ul>
						<div class="nothing" v-else><img src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/nothing.png"></div>
					</div>
					<div v-show="curSale == 2" class="list" v-waterfall-lower="getSalesList2" waterfall-disabled="disabledSales" waterfall-offset="100">
						<ul v-if="salesLists.length">
							<li v-for="item in salesLists" class="ellipsis">
								<template v-if="item.share_fans_id == 0">
									<span class="orange">{{item.nick}}</span> 购买了{{item.buy_num}}件商品
								</template>
								<template v-else>
									<span class="orange">{{item.nick}}</span> 获得了<span class="pink">{{item.money/100}}元</span>分享收益
								</template>
							</li>
						</ul>
						<div class="nothing" v-else><img src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/nothing.png"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import tool from '../../kits/Tools.js';
import { Waterfall } from 'vant';
import { Toast } from 'vant';
		//保存数据

export default {
	directives: {
		WaterfallLower: Waterfall('lower'),
		WaterfallUpper: Waterfall('upper'),
	},
	data() {
		return {
			imgPath:'',
			showSales:false,
			salesList:[],
			salesLists:[],
			curSale:1,
			ds_id:'',
			salesPage:1,
			salesPageNums:20,
			disabledSale:false,
			disabledSales:false,
		}
	},
	props:['fans_id','playHeight'],
	mounted() {
		this.imgPath = tool.imgPath();
		this.ds_id = tool.getQueryDsId();
	},
	methods: {
		showSalesList() {
			this.showSales = true;
			if(!this.disabledSale) {
				this.getSalesList();
			}
			if(!this.disabledSales) {
				this.getSalesList2();
			}
		},
		getSalesList() {
			var that = this;
			var url = tool.baseUrl1()+"/shop/top/get_data";
			var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id + '&page=' + this.salesPage + '&page_nums=' + this.salesPageNums + '&type=1';
			Toast.loading();
			this.disabledSale = true;
			this.axios.post(url, option).then(function(res) {
				var data = res.data;
				Toast.clear();
				if(data.code == "200") {
					that.salesPage++;
					if(data.data.length < that.salesPageNums) {
						that.disabledSale = true;
					} else {
						that.disabledSale = false;
					}
					that.salesList = that.salesList.concat(data.data);
				}
			}).catch(function(res) {
				Toast.clear();
				Toast('请求错误' + res.data.message);
			});
		},
		getSalesList2() {
			var that = this;
			var url = tool.baseUrl1()+"/shop/top/get_data";
			var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id + '&page=' + this.salesPage + '&page_nums=' + this.salesPageNums;
			Toast.loading();
			this.disabledSales = true;
			this.axios.post(url, option).then(function(res) {
				var data = res.data;
				Toast.clear();
				if(data.code == "200") {
					that.salesPage++;
					if(data.data.length < that.salesPageNums) {
						that.disabledSales = true;
					} else {
						that.disabledSales = false;
					}
					that.salesLists = that.salesLists.concat(data.data);
				}
			}).catch(function(res) {
				Toast.clear();
				Toast('请求错误' + res.data.message);
			});
		},
		closeSales() {
			this.showSales = false;
		},
		changeCur(index) {
			this.curSale = index;
		},
	}
}
</script>

<style scoped>
.wallet {
	position: absolute;
	left: 0;
	top: 41vw;
	z-index: 1260;
}

.wallet img {
	width: 52px;
	animation: tobig 1s linear infinite;
}

@keyframes tobig {
	0 {
		transform: scale(1, 1);
	}
	50% {
		transform: scale(1.1, 1.1);
	}
	100% {
		transform: scale(1, 1);
	}
}

.sales {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 4000;
}

.sales_musk {
	position: absolute;
	background: rgba(25, 25, 25, 0.83);
	width: 100%;
	height: 100%;
}

.sales_box {
	position: absolute;
	top: 10vh;
	left: 50%;
	width: 320px;
	margin-left: -160px;
}

.sales .close {
	position: absolute;
	top: 25px;
	right: 10px;
	width: 36px;
	height: 36px;
}

.sales .tabs {
	position: absolute;
	top: 150px;
	left: 50px;
	width: 226px;
	height: 220px;
	overflow: scroll;
}

.sales .tabs .list {
	height: 184px;
	overflow: scroll;
}

.sales li {
	height: 36px;
	padding: 0 5px;
	line-height: 36px;
	border-bottom: 1px solid #ffd889;
}

.sales li:last-child {
	border: none;
}

.sales .nothing {
	margin-top: 50px;
}
</style>